import { useUiStore } from '@/state/uiStore';

/**
 * First-person HUD. Renders only when ego mode is active:
 *   - a centred crosshair dot (brighter when a hinge is in reach);
 *   - an interact prompt just below the crosshair (`Front Door · [E] Open`);
 *   - a controls hint pinned bottom-centre so players know the bindings.
 *
 * Nothing here owns any state — the overlay reads `egoMode` and
 * `interactHint` straight from the store and otherwise stays inert.
 */
export function EgoOverlay() {
  const egoMode = useUiStore((s) => s.egoMode);
  const hint = useUiStore((s) => s.interactHint);
  if (!egoMode) return null;
  const active = hint !== null;
  return (
    <div className="ego-overlay" aria-hidden="true">
      <div className={`ego-crosshair ${active ? 'is-active' : ''}`} />
      {hint ? (
        <div className="ego-prompt">
          <span className="ego-prompt-label">{hint.label}</span>
          <span className="ego-prompt-key">[E]</span>
          <span className="ego-prompt-verb">{hint.verb}</span>
        </div>
      ) : null}
      <div className="ego-hint">
        <span>WASD move</span>
        <span>·</span>
        <span>Shift run</span>
        <span>·</span>
        <span>Space jump</span>
        <span>·</span>
        <span>Mouse look</span>
        <span>·</span>
        <span>E interact</span>
        <span>·</span>
        <span>ESC exit</span>
      </div>
    </div>
  );
}
